import { Router, Route } from "preact-router";
import { Layout } from "./components/Layout";
import Overview from "./pages/Overview";
import Clients from "./pages/Clients";
import Hardware from "./pages/Hardware";
import Speedtest from "./pages/Speedtest";

export default function App() {
  return (
    <Layout>
      <Router>
        <Route path="/" component={Overview} />
        <Route path="/overview" component={Overview} />
        <Route path="/clients" component={Clients} />
        <Route path="/hardware" component={Hardware} />
        <Route path="/speedtest" component={Speedtest} />
      </Router>
    </Layout>
  );
}
